<template>
  <div>
    <div v-if="this.location.latitude !== 0">
      <transition name="fade">
        <div v-if="!map.isReady" class="col-xs-12 cover" style="display: table">
          <div class="busy">{{ this.map.statusText }}</div>
        </div>
      </transition>
      <div ref="map" style="width: 100%; height: 300px"></div>
    </div>
    <div v-else class="no-map">No map available for address details.</div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';

export default {
  props: ['report', 'location'],
  data() {
    return {
      markers: [
        {
          position: {
            lat: parseFloat(this.location.latitude),
            lng: parseFloat(this.location.longitude),
          },
        },
      ],
      place: null,
      errors: [],
      center: {
        lat: parseFloat(this.location.latitude),
        lng: parseFloat(this.location.longitude),
      },
      path: [],
      options: {
        strokeColor: '#1f6b9b',
        strokeWeight: '5',
        strokeOpacity: '.6',
      },
      dataHasLoaded: true,
      map: {
        isReady: true,
        statusText: 'Loading',
      },
      currentUserOauthToken: localStorage.getItem('currentUserOauthToken'),
    };
  },
  mounted() {
    this.loadMapAPI();
  },
  methods: {
    loadMapAPI() {
      const loader = new Loader({
        apiKey: 'AIzaSyConcO-302VHr_LsceCG-CkiYgaC8jgrE8',
        version: 'weekly',
        libraries: ['places', 'marker'],
      });

      loader.load().then(() => {
        this.initMap();
      });
    },
    initMap() {
      const map = new google.maps.Map(this.$refs.map, {
        center: { 
          lat: this.center.lat, 
          lng: this.center.lng 
        },
        zoom: 15,
        mapId: 'e5f46a5479118f50'
      });

      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: { 
          lat: this.center.lat, 
          lng: this.center.lng 
        },
        map: map,
      });
    },
  },
};
</script>

<style scoped>
.cover {
  display: inline;
  background-color: #fff;
  z-index: 999;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.busy {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  color: #d6d6d6;
}

.no-map {
  background-color: #efefef;
  padding: 20px;
  text-align: center;
}
</style>
